import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment-timezone';

import styles from './TimeWithTimezoneLabel.scss';

export default class TimeWithTimezoneLabel extends Component {
    static propTypes = {
        timezone: PropTypes.string.isRequired,
        className: PropTypes.string
    };

    componentDidMount() {
        this.interval = setInterval(() => {
            this.forceUpdate();
        }, 1500);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const {timezone, className} = this.props;
        const tzObj = moment().tz(timezone);
        if (!tzObj || !tzObj.isValid()) {
            return null;
        }

        const containerClass = classnames(styles.container, className ? className : '');

        return (
            <div className={containerClass}>
                <div className={styles.timezoneIcon}/>
                {tzObj.format('h:mm A z')}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/TimeWithTimezoneLabel.js